import { render, staticRenderFns } from "./SBKHeader.vue?vue&type=template&id=040819eb&scoped=true&"
import script from "./SBKHeader.vue?vue&type=script&lang=ts&"
export * from "./SBKHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SBKHeader.vue?vue&type=style&index=0&id=040819eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040819eb",
  null
  
)

export default component.exports